import React, { useState } from "react";
import logo from "../assets/logo.svg";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";
import { HiMenu } from "react-icons/hi";

const NavLinks = ({ onClick }) => (
  <div className="flex flex-col md:flex-row m-8 items-center justify-center gap-8 text-lg lg:text-2xl">
    {["About", "Projects", "Resume", "Technologies"].map((item) => (
      <span
        key={item}
        className="cursor-pointer hover:scale-110 transition-transform duration-200"
        onClick={() => onClick(item)} // Optional click handler for mobile sidebar
      >
        {item}
      </span>
    ))}
  </div>
);

const SocialIcons = () => (
  <div className="flex items-center justify-center gap-4 text-xl md:text-2xl">
    <FaLinkedin
      className="cursor-pointer hover:scale-150 transition-transform duration-200"
      onClick={() =>
        window.open(
          "https://www.linkedin.com/in/navneetuniyal-dev150398/",
          "_blank"
        )
      }
    />
    <FaGithub className="cursor-pointer hover:scale-150 transition-transform duration-200" />
    <SiLeetcode
      className="cursor-pointer hover:scale-150 transition-transform duration-200"
      onClick={() =>
        window.open("https://leetcode.com/u/navneet_uniyal/", "_blank")
      }
    />
  </div>
);

const NavBar = ({ scrollToSection }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <nav className="mb-20 flex items-center justify-between p-4 relative z-50">
      {/* Logo */}
      <div className="flex flex-shrink-0 items-center">
        <img src={logo} alt="logo" className="w-20 sm:w-28 mx-2" />
      </div>

      {/* Hamburger Icon for Mobile */}
      <div className="md:hidden">
        <HiMenu className="text-3xl cursor-pointer" onClick={toggleSidebar} />
      </div>

      {/* Links for larger screens */}
      <div className="hidden md:flex">
        <NavLinks onClick={scrollToSection} />
      </div>

      {/* Social Icons */}
      <div className="hidden md:flex">
        <SocialIcons />
      </div>

      {/* Sidebar for mobile */}
      <div
        className={`fixed top-0 right-0 h-full w-2/3 bg-gray-900 shadow-lg transform transition-transform duration-300 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        } md:hidden z-50`}
      >
        <div className="flex flex-col p-6 text-xl">
          <button
            className="self-end mb-6 text-2xl font-bold"
            onClick={toggleSidebar}
          >
            ×
          </button>
          <NavLinks
            onClick={(item) => {
              scrollToSection(item);
              toggleSidebar(); // Close sidebar on mobile
            }}
          />
          <div className="mt-6">
            <SocialIcons />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
